import { Node_Type } from 'ricos-schema';

function getListSymbol(indentation, nodeTypeName) {
  const listSymbol = {
    [Node_Type.BULLETED_LIST]: ["disc", "circle", "square"],
    [Node_Type.ORDERED_LIST]: ["decimal", "lower-latin", "lower-roman"]
  }[nodeTypeName];
  return listSymbol[indentation % listSymbol.length];
}

export { getListSymbol };
//# sourceMappingURL=getListSymbol.js.map
